<div class="request-dialog">
  <div class="request-dialog-content">
    <b style="color: #7c7c7c">Please choose support area</b>
    <div class="mt-3">
      <mat-tab-group>
        <mat-tab label="Technical issues">
          <p class="mt-3" style="color: #373737">
            Something is not working right? Or do you need help adjusting your CAD file?
            <br />
            Here you can request technical support*. The request is non-binding. Your responsible account manager will
            get back to you as soon as possible.
          </p>

          <div *ngIf="(supportRequests.technicalSupport | keyvalue)?.length == 0">
            <mat-form-field appearance="fill" style="width: 100%">
              <mat-label>Your message</mat-label>
              <textarea matInput [(ngModel)]="technicalSupportMessage" data-cy="tech-support"></textarea>
            </mat-form-field>
            <div class="text-right">
              <button mat-button class="btn btn-sm request-dialog-colored-button" (click)="technicalSupport()">
                Submit
              </button>
            </div>
          </div>
          <div *ngIf="techSupport()">
            <p class="mt-3" style="color: #7c7c7c; margin: 2rem">
              <b>Your message</b>
              <br />
              {{ supportRequests.technicalSupport.message || 'No message added' }}
            </p>
            <div class="text-right">
              <button
                mat-button
                class="btn btn-sm request-dialog-colored-button"
                style="background: #e5a30f"
                (click)="unrequestSupport('technical')"
              >
                Withdraw request
              </button>
            </div>
          </div>
          <p class="mt-3" style="color: #7c7c7c; font-size: 12px">
            * Please note, that the support will be under the same
            <a (click)="openTermsofUse()" style="color: #21a0d2; cursor: pointer">Terms and conditions</a>
            as the app molded, including but not limited to liability and indemnification.
          </p>
        </mat-tab>
        <mat-tab label="Simulation results">
          <p class="mt-3" style="color: #373737">
            You want to have access to BASF know-how on simulation results? Here you can request support on your
            simulation results*.
            <br />
            The request is non-binding. Your responsible account manager will get back to you as soon as possible.
          </p>
          <div *ngIf="(supportRequests.simulationSupport | keyvalue)?.length == 0">
            <form [formGroup]="simulationRequestForm">
              <div>
                <mat-form-field appearance="fill" style="width: 100%">
                  <mat-label>Your message</mat-label>
                  <textarea matInput formControlName="message" data-cy="sim-support"></textarea>
                </mat-form-field>
              </div>
              <div class="text-right">
                <button
                  mat-button
                  class="btn btn-sm"
                  class="request-dialog-colored-button"
                  (click)="simulationSupport()"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
          <div *ngIf="simSupport()">
            <p class="mt-3" style="color: #7c7c7c; margin: 2rem">
              <b>Your message</b>
              <br />
              {{ supportRequests.simulationSupport.message || 'No message added' }}
            </p>
            <div class="text-right">
              <button
                mat-button
                class="btn btn-sm request-dialog-colored-button"
                style="background: #e5a30f"
                (click)="unrequestSupport('simulation')"
              >
                Withdraw request
              </button>
            </div>
          </div>
          <p class="mt-3" style="color: #7c7c7c; font-size: 12px">
            * Please note, that the support will be under the same
            <a (click)="openTermsofUse()" style="color: #21a0d2; cursor: pointer">Terms and conditions</a>
            as the app molded, including but not limited to liability and indemnification.
          </p>
        </mat-tab>
        <mat-tab label="Material choice">
          <p class="mt-3" style="color: #373737">
            You want to have access to BASF know-how on material choice? Here you can request support for your material
            choice*.
            <br />
            The request is non-binding. Your responsible account manager will get back to you as soon as possible.
          </p>
          <div *ngIf="(supportRequests.materialSupport | keyvalue)?.length == 0">
            <form [formGroup]="materialRequestForm">
              <div>
                <mat-form-field appearance="fill" style="width: 100%">
                  <mat-label>Your message</mat-label>
                  <textarea matInput formControlName="message" data-cy="material-support"></textarea>
                </mat-form-field>
              </div>
              <div class="text-right">
                <button mat-button class="btn btn-sm" class="request-dialog-colored-button" (click)="materialSupport()">
                  Submit
                </button>
              </div>
            </form>
          </div>
          <div *ngIf="matSupport()">
            <p class="mt-3" style="color: #7c7c7c; margin: 2rem">
              <b>Your message</b>
              <br />
              {{ supportRequests.materialSupport.message || 'No message added' }}
            </p>
            <div class="text-right">
              <button
                mat-button
                class="btn btn-sm request-dialog-colored-button"
                style="background: #e5a30f"
                (click)="unrequestSupport('material')"
              >
                Withdraw request
              </button>
            </div>
          </div>
          <p class="mt-3" style="color: #7c7c7c; font-size: 12px">
            * Please note, that the support will be under the same
            <a (click)="openTermsofUse()" style="color: #21a0d2; cursor: pointer">Terms and conditions</a>
            as the app molded, including but not limited to liability and indemnification.
          </p>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>
